module.exports = __webpack_public_path__ + "static/5-5452bf073d90d0261ce9a327e1e3006f.jpg";